import React, { useEffect, Fragment, useState, useRef } from 'react'
import C from 'classnames'
import dynamic from 'next/dynamic'
import Slider from 'react-slick'
import Modal from 'react-modal'
import { mediaQueryHOC } from '../../adapters/helpers/Hooks'
import { CarouselBlockConstants, Constants } from '../../adapters/helpers/Constants'
import PropTypes from 'prop-types'
import Block from '../../adapters/helpers/Block'
import { getColorStyle, stripHtml } from '../../adapters/helpers/Utils'
import { optimizeImage } from '../../adapters/helpers/pagespeedHelper'
const Image = dynamic(() => import('../Image/Image'))
const Icon = dynamic(() => import('../Icon/Icon'))
import VideoPlayer from '../VideoPlayer/VideoPlayer'
const YoutubeVideo = dynamic(() => import('../YoutubeVideo/YoutubeVideo'))
const ResponsiveImage = dynamic(() => import('../ResponsiveImage/ResponsiveImage'))
import { scrollIntoView } from '../../adapters/helpers/Scroll'
const SwitchTab = dynamic(() => import('../SwitchTab/SwitchTab'))


const CarouselBlock = (props) => {
    const { document: doc, isMedium, isSmall, isXSmall } = props
    const sliderRef = useRef(null)
    const carouselRef = useRef()
    const carouselClassName = (doc && doc.fields && doc.fields.className) || ''
    const isMobileView = isSmall || isXSmall
    const isOralCareWhyChooseSlider =
        carouselClassName.includes('ob-oral-care-education-slicker') &&
        carouselClassName.includes('au-why-choose-oralb')
    const shouldRenderSlider = !isOralCareWhyChooseSlider || isMobileView
    const isGetMostSlider = carouselClassName.includes('au-get-most-mob')
    const isOralCareEducationSlider = carouselClassName.includes('ob-oral-care-tips-for-age')
    const isLiveParityCenterSlider =
        carouselClassName.includes('au-why-choose-oralb') ||
        carouselClassName.includes('au-ob-why-elec') ||
        carouselClassName.includes('au-ob-video-first') ||
        carouselClassName.includes('ob-oralb-brush-heads')
    const liveParityCenterSliderSettings = isGetMostSlider
        ? {
            arrows: true,
            dots: true,
            centerMode: true,
            centerPadding: '30px',
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
        }
        : isOralCareEducationSlider && isMobileView
            ? {
                arrows: true,
                dots: true,
                centerMode: true,
                centerPadding: '30px',
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
            }
        : isLiveParityCenterSlider
            ? {
            arrows: true,
            dots: true,
            centerMode: true,
            centerPadding: '30px',
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
        }
        : {}
    const videoSettings = {
        ...doc?.fields?.carouselSettings,
        ...liveParityCenterSliderSettings,
        nextArrow:  doc?.fields?.rightArrowIcon?.fields?.file?.url && <img tabIndex={0} src={optimizeImage(doc?.fields?.rightArrowIcon?.fields?.file?.url)} data-action-detail='carousel_panel' alt={CarouselBlockConstants.rightArrow} fetchPriority="high"/>,
        prevArrow: doc?.fields?.leftArrowIcon?.fields?.file?.url && <img tabIndex={0} src={optimizeImage(doc?.fields?.leftArrowIcon?.fields?.file?.url)} data-action-detail='carousel_panel' alt={CarouselBlockConstants.leftArrow} fetchPriority="high"/>
    }
    const anchorId = doc?.fields?.anchorId
    const handleGAClassName = (ele) => {
        if (ele && ele.length > 0) {
            for (let i = 0; i < ele.length; i++) {
                ele[i].classList.add('event_button_click')
            }
        }
    }
    const handleClickTab = (index) => {
        if (!shouldRenderSlider || !sliderRef?.current) return
        sliderRef.current.slickGoTo(index)
    }

    const handleClickPageTab = (index) => {
        if (!shouldRenderSlider || !sliderRef?.current) return
        sliderRef.current.slickGoTo(index)
        setCurrentSlideIndex(index)
        setActiveTabIndex( index )
        const sliderElement = document.querySelector('.slick-slider')
        const sliderPosition = sliderElement.getBoundingClientRect().top + window.scrollY
        const offset = 200
        const mobileOffset = 70;
        (isSmall || isXSmall )?
        window.scrollTo({ top: sliderPosition - mobileOffset, behavior: 'smooth' })
        :
        window.scrollTo( { top: sliderPosition - offset, behavior: 'smooth' } )
        setTimeout(() => {
            const tabElement = document.querySelector('.carousel-tab-page.active')
            const parent = tabElement.parentElement
            parent.scrollLeft = tabElement.offsetLeft - ( parent.offsetWidth / 2 ) + ( tabElement.offsetWidth / 2 )
        }, 1000)
    }

    useEffect(() => {
        handleGAClassName(document.getElementsByClassName('slick-prev'))
        handleGAClassName(document.getElementsByClassName('slick-next'))
        setTimeout(() => {
            const videoButtonId = document?.getElementById('button-video')
            const htmlvideoButtonId = document?.getElementById('Electric-Brush-Brand-Video')
            videoButtonId?.addEventListener('click', () => {
                return setIsModalOpen(true)
            })
            htmlvideoButtonId?.addEventListener('click', () => {
                return setIsHtmlVideoModalOpen(true)
            })
        }, 3000)

        if (window?.location?.hash === `#${anchorId}` && carouselRef?.current) {
            let timeout = null
            window.setTimeout(() => {
                timeout = scrollIntoView(carouselRef.current, { behavior: 'smooth', block: 'nearest' })
            }, 250)

            return () => {
                clearTimeout(timeout)
            }
        }
    }, [])

    useEffect(() => {
        let timeout = null;

        const handleHashChange = () => {
            const hash = window.location.hash.substring(1);
            if (hash) {
                const targetElement = document.getElementById(hash);
                if (targetElement) {
                    timeout = window.setTimeout(() => {
                        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        const index = doc?.fields?.carouselItems?.findIndex(
                            (item) => item?.fields?.carouselTabItemId === hash
                        );
                        if (index !== -1) {
                            handleClickPageTab(index);
                            setActiveTabIndex(index); 
                        }
                    }, 250);
                }
            }
        };

        handleHashChange();

        window.addEventListener('hashchange', handleHashChange);

        return () => {
            window.removeEventListener('hashchange', handleHashChange);
            clearTimeout(timeout);
        };
    }, []);

    const hideAriaHiddenTiles = () => {
        Array.from(document.querySelectorAll('.slick-slide')).forEach((slide) => {
            slide.setAttribute('aria-hidden', false)
        })
    }

    useEffect(() => {
        hideAriaHiddenTiles()
    })

    const [selectedVariants, setSelectedVariants] = useState(Array(doc?.fields?.carouselItems?.length).fill(0))
    const [activeTabIndex, setActiveTabIndex] = useState(0)
    const [currentSlideIndex, setCurrentSlideIndex] = useState(0)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isHtmlvideoModalOpen, setIsHtmlVideoModalOpen] = useState(false)
    
    const tabItems = doc?.fields?.carouselItems?.map((item, index) => {
        return (
            <div
                tabIndex={0}
                role='button'
                key={index}
                className={`carousel-tab ${index === activeTabIndex ? 'active' : ''} event_button_click`}
                data-action-detail={item?.fields?.name}
                onClick={() => handleClickTab(index)}
                onKeyPress={() => handleClickTab(index)}
            >
                {item?.fields?.name}
            </div>
        )
    })

    const handleClickPageTabsScroll = ( index ) => {
        if (!shouldRenderSlider || !sliderRef?.current) return
        sliderRef.current.slickGoTo( index );
        setCurrentSlideIndex( index );
        setActiveTabIndex( index );
        setTimeout(() => {
            const tabElement = document.querySelector('.carousel-tab-page.active');
            const parent = tabElement.parentElement;
            const scrollOptions = {
                left: tabElement.offsetLeft - ( parent.offsetWidth / 2 ) + ( tabElement.offsetWidth / 2 ),
                behavior: 'smooth'
            }
            parent.scrollTo(scrollOptions)
        }, 1000);
    }
    const tabPageItems = doc?.fields?.carouselItems?.map((item, index) => {
        return (
            <div key={index} className={`carousel-tab-page ${index === activeTabIndex ? 'active' : ''}`} onClick={() => handleClickPageTab(index)} id={item?.fields?.carouselTabItemId}>
                <div className={item?.fields?.tabHtmlSection?.fields?.classNames} dangerouslySetInnerHTML={{ __html: item?.fields?.tabHtmlSection?.fields?.text }}></div>
            </div>
        )
    })

    useEffect(() => {
        setActiveTabIndex(currentSlideIndex)
    }, [currentSlideIndex])

    const closeModal = () => {
        setIsModalOpen(false)
        setIsHtmlVideoModalOpen(false)
    }

    const openModal = (event) => {
        event.preventDefault()
        setIsModalOpen(true)
    }
    const customStyles = {
        overlay: {
            position: 'fixed',
            top: '0px',
            left: '0px',
            right: '0px',
            bottom: '0px',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
        content: {
            border: 'none',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            padding: '0',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            maxWidth: '100rem',
            width: '90%',
        },
    }

    const renderVideo = (video) => {
        return video ? (video.videoId ? <YoutubeVideo document={video} /> : <VideoPlayer video={video} />) : null;
    }

    const handleSwitchTabCallBack = (data) => {
        if (!shouldRenderSlider || !sliderRef?.current) return
        setCurrentSlideIndex(data)
        setActiveTabIndex(data)
        handleClickPageTab(data)
    }

    const renderCarouselItem = (item, index) => {
        switch (item?.fields?.contentType) {
            case CarouselBlockConstants.productCard:
                return (
                    <a
                        key={index}
                        href={item?.fields?.destinationUrl?.fields?.url}
                        className={`card-link ${item?.fields?.destinationUrl?.fields?.linkClassName}`}
                        target={item?.fields?.destinationUrl?.fields?.isExternalLink ? '_blank' : null}
                        data-action-detail={item?.fields?.destinationUrl?.fields?.dataActionDetail}
                    >
                        <div className='carousel-card'>
                            {item?.fields?.productImage&&<Image image={item?.fields?.productImage} />}
                            {item?.fields?.productName && (
                                <h2 className='carousel-title'>
                                    {item?.fields?.productName} <Icon name={CarouselBlockConstants.chevronRight} />
                                </h2>
                            )}
                            {item?.fields?.title && <h2 className='carousel-heading'>{item?.fields?.title}</h2>}
                            {item?.fields?.cta && <h2 className='carousel-cta'>{item?.fields?.cta}</h2>}
                        </div>
                    </a>
                )
            case CarouselBlockConstants.cloudinaryVideo:
                return (
                    <div className='carousel-video' key={index}>
                        <VideoPlayer video={item?.fields} />
                    </div>
                )
            case CarouselBlockConstants.carouselTabItems:
                return (
                    <div className='ob-carousel-tab-content-conatiner' key={index}>
                        {item?.fields?.carouselTabInnerItem?.length > 0 &&
                            item?.fields?.carouselTabInnerItem.map((res, index) => {
                                return <React.Fragment key={index}>{new Block(res).renderBlockFromDocument(res)}</React.Fragment>
                            })}
                        {item?.fields?.carouselHtmlSection && (
                            <div className={item?.fields?.carouselHtmlSection?.fields?.classNames} dangerouslySetInnerHTML={{ __html: item?.fields?.carouselHtmlSection?.fields?.text }}></div>
                        )}
                        {(isMedium || isXSmall || isSmall) && item?.fields?.tabTitle && doc?.fields?.carouselItems?.length > 1 && <div className={'carousel-tabs-mobile'}>{item?.fields?.tabTitle} </div>}
                        {item?.fields?.tabItemDetailVideo ? (
                            <div>{new Block(item?.fields?.tabItemDetailVideo).renderBlockFromDocument(item?.fields?.tabItemDetailVideo)} </div>
                        ) : (
                            item?.fields?.tabImage && (
                                <div className='ob-carousel-tab-content-conatiner-image'>
                                    <ResponsiveImage document={item?.fields?.tabImage}></ResponsiveImage>
                                </div>
                            )
                        )}
                        <div className='ob-carousel-tab-content-conatiner-desc-wrapper'>
                            {item?.fields?.tabDescription && <span dangerouslySetInnerHTML={{ __html: item?.fields?.tabDescription }}></span>}
                            {item?.fields?.tabLinkPreviousDescription && <span dangerouslySetInnerHTML={{ __html: item?.fields?.tabLinkPreviousDescription }}></span>}
                            {item?.fields?.tabVideoTitle && (
                                <button className={`carousel-tab-video-cta carousel-tab-video-cta-${index}`} onClick={(e) => openModal(e)}>
                                    {item?.fields?.tabVideoTitle}
                                </button>
                            )}
                            {item?.fields?.tabLinkNextDescription && <span dangerouslySetInnerHTML={{ __html: item?.fields?.tabLinkNextDescription }}></span>}
                        </div>
                        {item?.fields?.tabItemLearnMoreCta && <div dangerouslySetInnerHTML={{ __html: item?.fields?.tabItemLearnMoreCta }} className='ob-learn-More-cta-wrapper'></div>}
                        {isModalOpen && item?.fields?.tabVideo && index === activeTabIndex && (
                            <Modal isOpen={isModalOpen} onRequestClose={closeModal} style={customStyles} htmlOpenClassName={'ob-carousel-tab-item-video'}>
                                <div className={'ob-carousel-tab-item-video-container'}>{renderVideo(item?.fields?.tabVideo?.fields)}</div>
                            </Modal>
                        )}
                    </div>
                )

            case CarouselBlockConstants.articleProductCard:
                const productVariants = item?.fields?.product?.[0]?.fields?.productVariants
                const productVariantImage = productVariants[selectedVariants[index]]?.fields?.productGridAsset
                return (
                    <div className='carousel-article-card' key={index}>
                        <div className='ob-bg-image-container'>
                            <Image image={item?.fields?.backgroundImage}>
                                <div className='article-items-wrapper'>
                                    <div className='ob-image-container'>
                                        <Image image={productVariantImage} />
                                    </div>
                                    <div className='text-variant-selector-container'>
                                        <h3>
                                            <a key={index} href={item?.fields?.destinationUrl?.fields?.url} className='card-link'>
                                                {item?.fields?.title}
                                            </a>
                                        </h3>
                                        <p>{item?.fields?.description}</p>
                                        <div className='ob-color-variant-button-container'>
                                            {productVariants.map((variant, i) => {
                                                const color = variant?.fields?.color
                                                if (!color) {
                                                    return null
                                                } else {
                                                    return !color?.fields?.colorImage ? (
                                                        <button
                                                            key={i}
                                                            aria-label={color?.fields?.name}
                                                            type={Constants.button}
                                                            className={C('ob-series__color ob-series__color--large-mobile event_buy_now_choose_product', {
                                                                ['ob-series__color--active']: i === selectedVariants[index],
                                                            })}
                                                            style={getColorStyle(color)}
                                                            data-action-detail={`${color?.fields?.name}_${stripHtml(item?.fields?.title)}`}
                                                            onClick={() => {
                                                                const newSelectedVariants = [...selectedVariants]
                                                                newSelectedVariants[index] = i
                                                                setSelectedVariants(newSelectedVariants)
                                                            }}
                                                            aria-pressed={i === selectedVariants[index]}
                                                        >
                                                            {color?.fields?.name}
                                                        </button>
                                                    ) : (
                                                        <img
                                                            key={i}
                                                            className={`event_buy_now_choose_product ob-series-product-color-img ${i === selectedVariants[index] ? 'ob-series__color--active' : ''}`}
                                                            data-action-detail={`${color?.fields.name}_${stripHtml(title)}`}
                                                            alt={color?.fields?.colorImage?.fields?.title}
                                                            src={optimizeImage(color?.fields?.colorImage?.fields?.file?.url, 'webp', 50)}
                                                            onClick={() => {
                                                                const newSelectedVariants = [...selectedVariants]
                                                                newSelectedVariants[index] = i
                                                                setSelectedVariants(newSelectedVariants)
                                                            }}
                                                        ></img>
                                                    )
                                                }
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </Image>
                        </div>
                    </div>
                )
            case CarouselBlockConstants.htmlBlock:
                return (
                    <React.Fragment key={index}>
                        <div className={item?.fields?.classNames} dangerouslySetInnerHTML={{ __html: item?.fields?.text }}></div>
                        {isHtmlvideoModalOpen && item?.fields?.buttonVideoBlock && (
                            <Modal isOpen={isHtmlvideoModalOpen} onRequestClose={closeModal} style={customStyles} htmlOpenClassName={'ob-html-video-button-wrapper'}>
                                <div className={'ob-html-video-container'}>{renderVideo(item?.fields?.buttonVideoBlock?.fields?.video?.fields)}</div>
                            </Modal>
                        )}
                    </React.Fragment>
                )
            case CarouselBlockConstants.contentBlock:
                return <div key={index}>{new Block(item).renderBlockFromDocument()}</div>
            case CarouselBlockConstants.miniContentBlock:
                return <div key={index}>{new Block(item).renderBlockFromDocument()} </div>
            case CarouselBlockConstants.RowLayoutCard:
                return <div key={index}>{new Block(item).renderBlockFromDocument()}</div>
            default:
                return <Image key={index} image={item} imageFormat='webp' imageQuality={50} />
        }
    }
    return (
        <Fragment>
            {doc?.fields?.corouselTitle && <h2 className={`carousel-heading ${doc?.fields?.carouselHeadingClassname ? doc?.fields?.carouselHeadingClassname : ''}`} dangerouslySetInnerHTML={{ __html: doc?.fields?.corouselTitle }} />}
            {doc?.fields?.carouselDescription && <div className={`carousel-description ${doc?.fields?.carouselDescriptionClassName}`} dangerouslySetInnerHTML={{ __html: doc?.fields?.carouselDescription }} />}
            {doc?.fields?.carouselItems?.map((item, index) => {
                if (item?.fields?.tabItemShopNowCta && index === activeTabIndex) {
                    return <div key={index} dangerouslySetInnerHTML={{ __html: item?.fields?.tabItemShopNowCta }} className='ob-shop-now-wrapper'></div>
                }
            })}
            {shouldRenderSlider && doc?.fields?.isCarouselTab && doc?.fields?.carouselItems?.length > 1 && !(isXSmall || isSmall) && (
                <div className={`carousel-tabs ${doc?.fields?.carouselTabItemsClassName ? doc?.fields?.carouselTabItemsClassName : ''}`}>{tabItems}</div>
            )}
            {shouldRenderSlider && doc?.fields?.isCarouselPageTab &&
              <div className='carouse-page-tabs-container'>
                    {doc?.fields?.leftArrowPageTab?.fields?.file?.url && (currentSlideIndex>0) && <button className='carousel-page-left-button' onClick={() => handleClickPageTabsScroll( currentSlideIndex - 1 )}><img tabIndex={0} src={optimizeImage(doc?.fields?.leftArrowPageTab?.fields?.file?.url)} data-action-detail='carousel_panel' alt={CarouselBlockConstants.leftArrow} fetchPriority="high"/></button>}
                    <div tabIndex={0} className={`carousel-page-tabs ${doc?.fields?.carouselTabItemsClassName ? doc?.fields?.carouselTabItemsClassName : ''}`}>{tabPageItems}</div>
                    {doc?.fields?.rightArrowPageTab?.fields?.file?.url && (currentSlideIndex < tabPageItems.length-1)  && <button className='carousel-page-right-button' onClick={() => handleClickPageTabsScroll( currentSlideIndex + 1 )}><img tabIndex={0} src={optimizeImage(doc?.fields?.rightArrowPageTab?.fields?.file?.url)} data-action-detail='carousel_panel' alt={CarouselBlockConstants.rightArrow} fetchPriority="high"/></button>}
              </div>
          }
            <section id={anchorId} ref={carouselRef}>
                {shouldRenderSlider ? (
                    <Slider
                        {...videoSettings}
                        ref={sliderRef}
                        className={doc?.fields?.className}
                        afterChange={(index) => {
                            setCurrentSlideIndex(index)
                        }}
                    >
                        {doc?.fields?.carouselItems?.map((item, index) => renderCarouselItem(item, index))}
                    </Slider>
                ) : (
                    <div className={`slick-slider ${doc?.fields?.className || ''} slick-initialized`}>
                        <div className='slick-list'>
                            <div className='slick-track' style={{ width: '100%', opacity: 1, transform: 'translate3d(0px, 0px, 0px)' }}>
                                {doc?.fields?.carouselItems?.map((item, index) => (
                                    <div
                                        key={index}
                                        data-index={index}
                                        className={`slick-slide slick-active ${index === 0 ? 'slick-current' : ''}`}
                                        tabIndex={-1}
                                        aria-hidden='false'
                                        style={{ width: `${100 / (doc?.fields?.carouselItems?.length || 1)}%` }}
                                    >
                                        <div>{renderCarouselItem(item, index)}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </section>
            {doc?.fields?.switchTabs && <SwitchTab document={doc.fields.switchTabs} changeTabIndex={currentSlideIndex} handleSwitchTabCallBack={handleSwitchTabCallBack} carouselSwitchTab={true} carouselProp={props}></SwitchTab>}
            {doc?.fields?.imageBelowText && <p className='carousel-image-below-text' dangerouslySetInnerHTML={{ __html: doc?.fields?.imageBelowText }} />}
        </Fragment>
    )
}

export default mediaQueryHOC(CarouselBlock)

CarouselBlock.propTypes = {
    document: PropTypes.any,
    isMedium: PropTypes.bool,
    isLarge: PropTypes.bool,
    isXXLarge: PropTypes.bool,
    isSmall: PropTypes.bool,
    isXSmall: PropTypes.bool,
}
